import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import './sidebar.css';
import logo from "../Images/Logo.png" 

const Sidebar = ({ darkMode, setDarkMode }) => {
  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <Link to="/">
          <img src={logo} alt='რა? სად? როდის?' />
        </Link>
      </div>
      
      <div className="sidebar-nav">
        <NavLink to="/" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 12h18M3 6h18M3 18h18" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <span>მთავარი გვერდი</span>
        </NavLink>
        
        <NavLink to="/packetGen" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M7 7H6a2 2 0 00-2 2v9a2 2 0 002 2h9a2 2 0 002-2v-1M9 12h10M7 12h.01M3 12h.01M17 12h.01M21 12h.01M11 16.5h2" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <span>პაკეტების გენერირება</span>
        </NavLink>
        
        {/* <NavLink to="/leaderboard" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M8 21h4M12 21h4M15 8a3 3 0 11-6 0 3 3 0 016 0zM17 11v7M12 3v2M19 5l-1.5 1.5M5 5l1.5 1.5" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <span>ლიდერბორდი
          </span>
        </NavLink> */}

        <NavLink to="/about" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 16v-4M12 8h.01" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <span>ჩვენს შესახებ</span>
        </NavLink>
      </div>

      <div className="sidebar-notice">
        <div className="notice-content">
          <svg className="notice-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <p>საიტი გაკეთების პროცესშია ინფორმაცია რასაც საიტზე ხედავთ არის სატესტო</p>
        </div>
      </div>
      
      {/* <div className="sidebar-footer">
        <button className="theme-toggle" onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="5"></circle>
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          )}
        </button>
      </div> */}
    </div>
  );
};

export default Sidebar;